import { updateArrElementById } from "@utilities";
import { AppConfigConstants } from "./constants";

const DEFAULT_PAGING = {
  page: 1,
  pageSize: 20,
  totalItems: 0,
  totalPages: 1
};

const defaultState = {
  isLoading: {
    countriesRiskList: false,
    updateCountryRisk: false,

    updateRiskItem: false,
    riskList: false,

    naceBlockers: false,
    updateNaceBlockersItem: false,

    allClientRiskCraScreen: false
  },

  countriesRisksConfig: {
    paging: DEFAULT_PAGING,
    items: undefined,
    isFiltered: false
  },

  risksConfig: {
    paging: DEFAULT_PAGING,
    items: undefined,
    isFiltered: false
  },

  naceBlokersConfig: {
    paging: DEFAULT_PAGING,
    items: undefined,
    isFiltered: false
  },
  allClientRiskCraScreen: [],
  errors: undefined
};

export const AppConfigReducer = (state = defaultState, action) => {
  switch (action.type) {
    case AppConfigConstants.GET_COUNTRY_RISK_LIST_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          countriesRiskList: true
        }
      };
    case AppConfigConstants.GET_COUNTRY_RISK_LIST_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          countriesRiskList: false
        },
        countriesRisksConfig: action.payload
      };
    case AppConfigConstants.GET_COUNTRY_RISK_LIST_ERROR:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          countriesRiskList: false
        },
        errors: action.error
      };

    case AppConfigConstants.UPDATE_COUNTRY_RISK_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          updateCountryRisk: true
        }
      };
    case AppConfigConstants.UPDATE_COUNTRY_RISK_SUCCESS: {
      const newCountryItems = updateArrElementById(
        state.countriesRisksConfig.items,
        action.payload
      );
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          updateCountryRisk: false
        },
        countriesRisksConfig: {
          ...state.countriesRisksConfig,
          items: newCountryItems
        }
      };
    }
    case AppConfigConstants.UPDATE_COUNTRY_RISK_ERROR:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          updateCountryRisk: false
        },
        errors: action.error
      };

    case AppConfigConstants.UPDATE_RISK_ITEM_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          updateRiskItem: true
        }
      };
    case AppConfigConstants.UPDATE_RISK_ITEM_SUCCESS: {
      const newRiskItems = updateArrElementById(state.risksConfig.items, action.payload);
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          updateRiskItem: false
        },
        risksConfig: {
          ...state.risksConfig,
          items: newRiskItems
        }
      };
    }
    case AppConfigConstants.UPDATE_RISK_ITEM_ERROR:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          updateRiskItem: false
        },
        errors: action.error
      };

    case AppConfigConstants.GET_RISK_LIST_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          riskList: true
        }
      };
    case AppConfigConstants.GET_RISK_LIST_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          riskList: false
        },
        risksConfig: action.payload
      };
    case AppConfigConstants.GET_RISK_LIST_ERROR:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          riskList: false
        },
        errors: action.error
      };

    case AppConfigConstants.GET_NACE_BLOCKERS_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          naceBlockers: true
        }
      };
    case AppConfigConstants.GET_NACE_BLOCKERS_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          naceBlockers: false
        },
        naceBlokersConfig: action.payload
      };
    case AppConfigConstants.GET_NACE_BLOCKERS_ERROR:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          naceBlockers: false
        },
        errors: action.error
      };

    case AppConfigConstants.UPDATE_NACE_BLOCKERS_ITEM_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          updateNaceBlockersItem: true
        }
      };
    case AppConfigConstants.UPDATE_NACE_BLOCKERS_ITEM_SUCCESS: {
      const newRiskItems = updateArrElementById(state.naceBlokersConfig.items, action.payload);
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          updateNaceBlockersItem: false
        },
        naceBlokersConfig: {
          ...state.naceBlokersConfig,
          items: newRiskItems
        }
      };
    }
    case AppConfigConstants.UPDATE_NACE_BLOCKERS_ITEM_ERROR:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          updateNaceBlockersItem: false
        },
        errors: action.error
      };

    case AppConfigConstants.GET_CALCULATE_ALL_CLIENT_RISKS_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          allClientRiskCraScreen: true
        }
      };
    case AppConfigConstants.GET_CALCULATE_ALL_CLIENT_RISKS_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          allClientRiskCraScreen: false
        },
        allClientRiskCraScreen: action.payload
      };
    case AppConfigConstants.GET_CALCULATE_ALL_CLIENT_RISKS_ERROR:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          allClientRiskCraScreen: false
        },
        errors: action.error
      };
    default:
      return state;
  }
};
